import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/organization/$slug/automations")({
  component: Automations,
});

function Automations() {
  return (
    <div>
      <h1 className="text-2xl font-bold text-primary-darker">Automations</h1>
      <p className="mt-2 text-gray-500">Configure automated workflows.</p>
    </div>
  );
}
